import { useRef } from 'react';
import { ResizeObserver as Polyfill } from '@juggle/resize-observer';
const ResizeObserver = (set: VoidFunction) => {
  return typeof window !== 'undefined' ? new window.ResizeObserver(set) : new Polyfill(set);
};
export interface IOptionsObject {
  setFontSize?: boolean;
  globalVariableName?: string;
  lockFontSize?: boolean;
}
export interface IuseResponsiveFontSizeProps {
  ratio: number;
  optionsObject?: IOptionsObject;
}
const useResponsiveFontSize = (ratio: number, optionsObject: IOptionsObject = {}) => {
  const {
    setFontSize = true,
    globalVariableName,
    lockFontSize = false
  } = optionsObject;
  const ref = useRef<HTMLElement | null>(null);
  const locked = useRef<boolean>(lockFontSize);
  const set = () => {
    if (!ref.current || locked.current) return;
    const fontSize = ref.current.clientHeight * ratio;
    // Skip if height is 0 (element not yet laid out) - ResizeObserver will catch it
    if (fontSize <= 0) return;
    const fontSizePx = `${fontSize}px`;
    if (setFontSize) ref.current.style.fontSize = fontSizePx;
    if (globalVariableName) document.documentElement.style.setProperty(globalVariableName, fontSizePx);
  };
  const resizeObserver = ResizeObserver(set);
  const onRefChange = (node: HTMLElement | null) => {
    if (!node) return;
    ref.current = node;
    // Set font-size immediately to prevent visual jump, then observe for resizes
    set();
    resizeObserver.observe(node);
  };
  return onRefChange;
};
export default useResponsiveFontSize;